<script setup lang="ts">
import { PhxsgText } from '../Text';
</script>

<template>
  <PhxsgText use="span" variant="label" size="extra-small" color="primary" uppercase class="phxsg-tag">
    <slot />
  </PhxsgText>
</template>

<style src="./tag.css" />
